export default {
    tenants:[],
    countPerPool: {},
    currentTenant: '',
    paginatedTenants: null,
}